var $1155cb8ff77ceb92$exports = {};
$1155cb8ff77ceb92$exports = {
    "backButton": (args)=>`\u{8FD4}\u{56DE} ${args.prevMenuButton}`,
    "moreActions": `\u{66F4}\u{591A}\u{64CD}\u{4F5C}`,
    "unavailable": `\u{4E0D}\u{53EF}\u{7528}\u{FF0C}\u{5C55}\u{5F00}\u{4EE5}\u{67E5}\u{770B}\u{8BE6}\u{7EC6}\u{4FE1}\u{606F}`
};


export {$1155cb8ff77ceb92$exports as default};
//# sourceMappingURL=zh-CN.mjs.map
